var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TopBarButtonIcon',{attrs:{"button-icon":_vm.fullscreenIcon,"size":_vm.fullscreenButtonSize,"button-style":_vm.fullscreenButtonStyle},on:{"button-click":_vm.toggleFullscreen}})
}
var staticRenderFns = []

export { render, staticRenderFns }